<template>
  <div id="resultList" class="listTable">
    <div class="d1 lp">
      自定义锁词
      <div @click="coreWords">提取核心词</div>
      <div class="cl" @click="clear">清空</div>
      <div>
        <hr />
      </div>
      <span>
        <el-switch :width="33" v-model="coreSwitch"> </el-switch>
      </span>
    </div>
    <div class="lp" v-if="coreSwitch">
      <div class="lspan">
        <ul>
          <li v-for="(item, index) in inputWordList" :key="index">
            <el-input
              size="mini"
              placeholder="核心词锁词"
              :maxlength="30"
              v-model="coreWordList[item]"
              class="el-input"
              clearable
              :disabled="!coreSwitch"
            >
            </el-input>
          </li>
        </ul>
      </div>
    </div>
    <div class="d1 lp">
      固有名锁词
      <div>
        <hr class="hr2" />
      </div>
      <span>
        <el-switch :width="33" v-model="inherentSwitch"> </el-switch>
      </span>
    </div>
    <div class="lp" v-if="inherentSwitch">
      <div class="guyoudiv">
        <div
          style="display: flex;flex-flow: row wrap;"
          v-if="
            nameList.length > 0 || placeList.length > 0 || organList.length > 0
          "
        >
          <div
            class="item"
            v-for="(item, index) in nameList"
            :key="index + 'name'"
          >
            <div>
              <img src="../../assets/image/wyc/name.png" />
            </div>
            <div class="name">{{ item.Name }}</div>
            <span
              @click="deleteN(item.Name, 'name')"
              class="iconfont"
              style="color: #c0b2b2;margin-left: 3px"
              >&#xe602;</span
            >
          </div>
          <div
            class="item"
            v-for="(item, index) in placeList"
            :key="index + 'place'"
          >
            <div>
              <img src="../../assets/image/wyc/place.png" />
            </div>
            <div class="name">{{ item.Name }}</div>
            <span
              @click="deleteN(item.Name, 'place')"
              class="iconfont"
              style="color: #c0b2b2;margin-left: 3px"
              >&#xe602;</span
            >
          </div>
          <div
            class="item"
            v-for="(item, index) in organList"
            :key="index + 'organ'"
          >
            <div>
              <img src="../../assets/image/wyc/organization.png" />
            </div>
            <div class="name">{{ item.Name }}</div>
            <span
              @click="deleteN(item.Name, 'organ')"
              class="iconfont"
              style="color: #c0b2b2;margin-left: 3px;margin-top: -2px;"
              >&#xe602;</span
            >
          </div>
        </div>
        <div v-else class="flex-box">没有识别到固有名</div>
      </div>
    </div>
    <div class="d1 lp">
      换词结果示例
      <dd>
        (提取首段内容效果如下）
      </dd>
      <div>
        <hr class="hr3" />
      </div>
    </div>
    <div class="lp">
      <div class="lspan">
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 5 }"
          v-model="resultMsg"
          resize="none"
          readonly
        ></el-input>
        <button v-if="backMsg" class="btn_inner">
          相似度：{{ likeNumber }}%
        </button>
      </div>
    </div>
    <div class="lp center mt15">
      <button :class="[sending ? 'btn3' : 'btn']" @click="sendMsg()">
        开始智能换词
      </button>
      <button v-if="sending" class="btn2" @click="clearMsg">取消操作</button>
    </div>
  </div>
</template>

<script>
import { SendPostData } from "../../assets/script/model";
import { mapActions } from "vuex";

export default {
  name: "SetOriginal",
  data() {
    return {
      coreSwitch: true,
      inherentSwitch: true,
      sending: false,
      backMsg: false,
      inputWordList: ["word0", "word1", "word2", "word3", "word4", "word5"],
      coreWordList: {
        word0: "",
        word1: "",
        word2: "",
        word3: "",
        word4: "",
        word5: ""
      },
      resultMsg: "",
      nameList: [],
      placeList: [],
      organList: [],
      likeNumber: 0
    };
  },
  watch: {
    resultMsg(newval) {
      newval ? (this.backMsg = true) : (this.backMsg = false);
    },
    contentHeight: {
      handler: function(val) {
        this.getLineHeight(val);
      }
    }
  },
  computed: {
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      },
      set(val) {
        this.$store.state.contents.contentHeight = val;
      }
    }
  },
  mounted() {
    this.listenMessage();
    this.getid = setInterval(() => {
      let getBox = document.getElementById("resultList");
      if (getBox) {
        clearInterval(this.getid);
        this.getLineHeight(this.contentHeight);
      }
    });
  },
  beforeDestroy() {
    this.$messenger.clear();
  },
  methods: {
    ...mapActions("api", ["APermission"]),
    listenMessage() {
      let that = this;
      //固有名硕词
      this.notReplace();
      this.getLocalCoreWords();

      this.$messenger.listen("notreplace", e => {
        let getMsg = e.data.Data;
        if (getMsg) {
          that.nameList = getMsg.Name;
          that.placeList = getMsg.Place;
          that.organList = getMsg.Organization;
          let notReplace = that.getnotReplace();
          let corewords = that.getcoreWords();
          that.getDemo(notReplace, corewords);
        }
      });

      this.$messenger.listen("akeydemo", e => {
        let getMsg = e.data.Data;
        if (getMsg) {
          that.resultMsg = getMsg.RestructureTxt;
          that.likeNumber = that.fiter(getMsg.Like);
        }
      });

      this.$messenger.listen("akeykernelwords", e => {
        let getMsg = e.data.Data;
        if (getMsg) {
          for (let i = 0; i < getMsg.length; i++) {
            that.coreWordList["word" + i] = getMsg[i];
          }
        }
      });

      this.$messenger.listen("akey", () => {
        that.sending = false;
      });
      this.$messenger.listen("cancel", () => {
        that.sending = false;
      });

      // window.addEventListener("message", function(e) {
      //   if (e.data && e.data.cmd === "_5118_Response_Message_Content") {
      //     // if (!e.data.isclose && e.data.btn === "akeykernelwords") {
      //     //   let getMsg = e.data.data.Data;
      //     //   if (getMsg) {
      //     //     for (let i = 0; i < getMsg.length; i++) {
      //     //       that.coreWordList["word" + i] = getMsg[i];
      //     //     }
      //     //   }
      //     // }
      //     // if (!e.data.isclose && e.data.btn === "notreplace") {
      //     //   let getMsg = e.data.data.Data;
      //     //   if (getMsg) {
      //     //     that.nameList = getMsg.Name;
      //     //     that.placeList = getMsg.Place;
      //     //     that.organList = getMsg.Organization;
      //     //     let notReplace = that.getnotReplace();
      //     //     let corewords = that.getcoreWords();
      //     //     that.getDemo(notReplace, corewords);
      //     //   }
      //     // }
      //     // if (!e.data.isclose && e.data.btn === "akeydemo") {
      //     //   let getMsg = e.data.data.Data;
      //     //   if (getMsg) {
      //     //     that.resultMsg = getMsg.RestructureTxt;
      //     //     that.likeNumber = that.fiter(getMsg.Like);
      //     //   }
      //     // }
      //     // if (!e.data.isclose && e.data.btn === "akey") {
      //     //   that.sending = false;
      //     // }
      //     // if (!e.data.isclose && e.data.btn === "cancel") {
      //     //   that.sending = false;
      //     // }
      //   }
      // });
    },
    getcoreWords() {
      let resMsg = "";
      for (let i = 0; i < 6; i++) {
        if (resMsg === "") {
          resMsg = this.coreWordList["word" + i];
        } else {
          resMsg = resMsg + "|" + this.coreWordList["word" + i];
        }
      }
      localStorage.setItem("wyc_aKey_filtter", resMsg);
      return resMsg;
    },
    getLocalCoreWords() {
      let resMsg = localStorage.getItem("wyc_aKey_filtter");
      if (resMsg) {
        resMsg = resMsg.split("|");
        for (let i = 0; i < resMsg.length; i++) {
          this.coreWordList["word" + i] = resMsg[i];
        }
      }
    },
    getnotReplace() {
      let resMsg = "";
      if (this.nameList) {
        for (let item of this.nameList) {
          if (resMsg === "") {
            resMsg = item.Name;
          } else {
            resMsg = resMsg + "|" + item.Name;
          }
        }
      }
      if (this.placeList) {
        for (let item of this.placeList) {
          if (resMsg === "") {
            resMsg = item.Name;
          } else {
            resMsg = resMsg + "|" + item.Name;
          }
        }
      }
      if (this.organList) {
        for (let item of this.organList) {
          if (resMsg === "") {
            resMsg = item.Name;
          } else {
            resMsg = resMsg + "|" + item.Name;
          }
        }
      }
      return resMsg;
    },
    coreWords() {
      if (this.coreSwitch) {
        let sendData = new SendPostData();
        sendData.btn = "akeykernelwords";
        this.sendNewMsg(sendData.btn, sendData.data);
        // this.SendMessage(sendData);
      }
    },
    notReplace() {
      if (this.inherentSwitch) {
        let sendData = new SendPostData();
        sendData.btn = "notreplace";
        // this.SendMessage(sendData);
        this.sendNewMsg(sendData.btn, sendData.data);
      }
    },
    clear() {
      if (this.coreSwitch) {
        for (let i = 0; i < 6; i++) {
          this.coreWordList["word" + i] = "";
        }
      }
    },
    getDemo(notReplace, corewords) {
      let sendData = new SendPostData();
      sendData.btn = "akeydemo";
      sendData.data = { type: 0, notReplace: notReplace, corewords: corewords };
      // console.log(sendData);
      // this.SendMessage(sendData);
      this.sendNewMsg(sendData.btn, sendData.data);
    },
    async sendMsg() {
      let result = await this.APermission({ SysName: "wycakeyanalyze" });
      if (result.errorCode > 0) {
        this.$message({
          message: result.errorMess,
          type: "error",
          showClose: true
        });
        return;
      }
      if (result.data > 0 || result.data === -1) {
        if (this.sending === false) {
          this.sending = true;
          let sendData = new SendPostData();
          sendData.btn = "akey";
          this.getcoreWords();
          let notReplace = this.getnotReplace();
          let corewords = this.getcoreWords();
          sendData.data = { corewords: corewords, notReplace: notReplace };
          this.SendMessage(sendData);
        } else {
          this.$message({
            message: "正在智能原创中...",
            type: "warning"
          });
        }
      } else {
        this.insertConfig.showUpgrade(true, "获取更多使用次数");
        // this.$message({
        //   message: "您的句式重构次数已用尽",
        //   type: "error",
        //   showClose: true
        // });
        this.sending = false;
      }
    },
    deleteN(name, type) {
      console.log(this.nameList);
      if (type === "name") {
        this.nameList.splice(
          this.nameList.findIndex(item => item.Name === name),
          1
        );
      }
      if (type === "place") {
        this.placeList.splice(
          this.placeList.findIndex(item => item.Name === name),
          1
        );
      }
      if (type === "organ") {
        this.organList.splice(
          this.organList.findIndex(item => item.Name === name),
          1
        );
      }
      console.log(name);
    },
    clearMsg() {
      this.sending = false;
      let sendData = new SendPostData();
      sendData.btn = "cancel";
      this.SendMessage(sendData);
    },
    fiter(number) {
      let getNumber = 0;
      getNumber = (number * 100).toFixed(2);
      if (getNumber === "100.00") getNumber = 100;
      return getNumber;
    },
    getLineHeight(windowheight) {
      let toolbar = document.querySelector(".el-header");

      let editorToolbarHeight = 0;
      if (toolbar !== null && toolbar !== undefined) {
        editorToolbarHeight = toolbar.offsetHeight;
      }

      let righttitle = document.querySelector(".tLeft");

      let righttitleHeight = 0;
      if (righttitle !== null && righttitle !== undefined) {
        righttitleHeight = righttitle.offsetHeight;
      }
      let editorStatusBarHeight = 100;
      let realHeight =
        windowheight -
        editorToolbarHeight -
        editorStatusBarHeight -
        righttitleHeight;
      let getListBox = document.getElementById("resultList");
      this.tabHeight = realHeight + 60;
      if (getListBox) getListBox.style.height = this.tabHeight + "px";
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/mixin";
* {
  font-size: 13px;
}
dd {
  color: #eeb733;
  display: inline-block;
  font-size: 12px;
}
li {
  display: inline-block;
  margin-bottom: 10px;
  &:nth-child(2),
  &:nth-child(4),
  &:nth-child(6) {
    margin-left: 20px;
  }
}
.listTable {
  height: 300px;
  width: 100%;
  overflow: auto;
  overscroll-behavior-y: contain;
}
.el-input {
  width: 200px;
}
.d1 {
  line-height: 30px;
  div {
    display: inline-block;
    margin-left: 10px;
    color: @theme-color;
    cursor: pointer;
    text-decoration: underline;
  }
  span {
    float: right;
    margin-top: -3px;
  }
  .cl {
    color: red;
  }
}
.lp {
  padding: 5px 15px;
}
hr {
  .dashed();
  width: 205px;
}
.hr2 {
  width: 320px;
}
.hr3 {
  width: 225px;
  margin-left: -15px;
}
.lspan {
  background-color: @boxback-color;
  line-height: 30px;
  padding: 10px 10px;
  border-radius: 5px;
  height: 130px;
}
.guyoudiv {
  background-color: @boxback-color;
  line-height: 30px;
  padding: 10px 10px;
  border-radius: 5px;
  min-height: 40px;
  max-height: 130px;
  overflow-y: auto;
  font-size: 12px !important;
  .item {
    display: flex;
    align-items: center;
    width: 50%;
    height: 28px;
    span {
      cursor: pointer;
    }
    .name {
      margin-left: 3px;
      margin-top: -4px;
      font-size: 12px;
    }
  }
}
.btn {
  .btn();
  padding: 6px 15px;
}
.btn2 {
  .btn();
  background-color: #bfbfbf;
  border: 0;
  padding: 7px 30px;
}
.btn3 {
  .btn();
  padding: 7px 15px;
  background-color: #b7cdfc;
  border: 0;
}
</style>
<style lang="less">
@import "../../assets/style/el";
</style>
